import { render, staticRenderFns } from "./AlertaCenario.vue?vue&type=template&id=4a23a73f&scoped=true&"
import script from "./AlertaCenario.vue?vue&type=script&lang=js&"
export * from "./AlertaCenario.vue?vue&type=script&lang=js&"
import style0 from "./AlertaCenario.vue?vue&type=style&index=0&id=4a23a73f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a23a73f",
  null
  
)

export default component.exports